/** Общий каталог внешности: клиентская примерочная и проверка гостей дворика. */
export const CAT_TYPES = [
  { id: 'dracula', label: 'Дракула · только Яне', description: 'Чёрный хранитель с бархатным плащом и собственными ритуалами', name: 'Дракула', coat: 'black', eyes: 'red' },
  { id: 'mainecoon', label: 'Мейн-кун', description: 'Кисточки на ушах, полосатая шубка и пышная грива', name: 'Тайга', coat: 'brown', eyes: 'green' },
  { id: 'siamese', label: 'Сиамская', description: 'Голубые глаза, тёмная маска и изящные лапы', name: 'Сима', coat: 'cream', eyes: 'blue' },
  { id: 'bengal', label: 'Бенгальская', description: 'Золотистая шерсть с леопардовыми розетками', name: 'Беня', coat: 'ginger', eyes: 'green' },
  { id: 'persian', label: 'Персидская', description: 'Белая пушистая шубка и круглая мордочка', name: 'Облачко', coat: 'white', eyes: 'amber' },
  { id: 'sphynx', label: 'Сфинкс', description: 'Бархатная кожа, большие уши и тонкий хвост', name: 'Финик', coat: 'silver', eyes: 'green' },
  { id: 'fluffy', label: 'Пушистый', description: 'Острые ушки и пушистый хвост', name: 'Ночка', coat: 'black', eyes: 'green' },
  { id: 'plush', label: 'Плюшевый', description: 'Круглые щёки и загнутые ушки', name: 'Плюш', coat: 'silver', eyes: 'amber' },
  { id: 'bulldog', label: 'Бульдог', description: 'Французский бульдог с большими ушками', name: 'Бублик', coat: 'cream', eyes: 'amber' },
  { id: 'vizsla', label: 'Выжла', description: 'Рыжая Чапа с мягкими висячими ушами', name: 'Чапа', coat: 'ginger', eyes: 'amber' },
  { id: 'pied', label: 'Пятнистый бульдог', description: 'Белая мордочка и тёмные пятна, как на фотографии', name: 'Бублик', coat: 'white', eyes: 'amber' },
] as const;

export const COAT_COLORS = [
  { id: 'black', label: 'Чёрный', color: '#30313b', shadow: '#07080d', light: '#696977' },
  { id: 'ginger', label: 'Рыжий', color: '#d78b42', shadow: '#44291c', light: '#ffe0a0' },
  { id: 'red', label: 'Красный', color: '#c95445', shadow: '#4e2024', light: '#ffbaa0' },
  { id: 'cream', label: 'Светлый кремовый', color: '#e7d8b9', shadow: '#6c6255', light: '#fff9eb' },
  { id: 'brown', label: 'Каштановый', color: '#855b43', shadow: '#291b19', light: '#d7b494' },
  { id: 'silver', label: 'Серебристый', color: '#9b9da5', shadow: '#363942', light: '#e9eaf0' },
  { id: 'white', label: 'Белый', color: '#eeeef0', shadow: '#777c87', light: '#ffffff' },
  { id: 'lilac', label: 'Лиловый', color: '#b094c9', shadow: '#493751', light: '#eddcfa' },
] as const;

export const EYE_COLORS = [
  { id: 'green', label: 'Зелёные', color: '#b7d74d' },
  { id: 'amber', label: 'Янтарные', color: '#f0b04e' },
  { id: 'blue', label: 'Голубые', color: '#79cbed' },
  { id: 'violet', label: 'Фиолетовые', color: '#c298ed' },
  { id: 'red', label: 'Рубиновые', color: '#f16a71' },
] as const;

export const ACCESSORY_COLORS = [
  { id: 'blue', label: 'Синий', color: '#5685db' },
  { id: 'rose', label: 'Розовый', color: '#e77e9b' },
  { id: 'mint', label: 'Мятный', color: '#62bb9b' },
  { id: 'gold', label: 'Золотой', color: '#e7b951' },
  { id: 'violet', label: 'Сиреневый', color: '#a48bdd' },
  { id: 'red', label: 'Красный', color: '#d95d60' },
] as const;

export const NECKWEAR = [
  { id: 'none', label: 'Без украшения' },
  { id: 'collar', label: 'Ошейник с бубенчиком' },
  { id: 'bow', label: 'Бабочка' },
  { id: 'bandana', label: 'Косынка' },
  { id: 'vampire', label: 'Плащ Дракулы и клыки' },
  { id: 'scarf', label: 'Вязаный шарф' },
  { id: 'tie', label: 'Деловой галстук' },
  { id: 'sailor', label: 'Матросский воротник' },
  { id: 'sweater', label: 'Уютный свитер' },
  { id: 'medal', label: 'Медаль помощника' },
  { id: 'hero', label: 'Плащ супергероя' },
  { id: 'raincoat', label: 'Дождевик' },
  { id: 'kimono', label: 'Кимоно с сакурой' },
  { id: 'explorer', label: 'Жилет путешественника' },
  { id: 'stargazer', label: 'Звёздная мантия' },
  { id: 'royal', label: 'Королевская пелерина' },
  { id: 'overalls', label: 'Джинсовый комбинезон' },
] as const;
export const HEADWEAR = [
  { id: 'none', label: 'Без головного убора' },
  { id: 'beanie', label: 'Шапочка с помпоном' },
  { id: 'crown', label: 'Корона' },
  { id: 'flower', label: 'Цветок у ушка' },
  { id: 'beret', label: 'Берет художника' },
  { id: 'wizard', label: 'Шляпа волшебника' },
  { id: 'party', label: 'Праздничный колпак' },
  { id: 'cap', label: 'Кепка исследователя' },
  { id: 'headphones', label: 'Наушники' },
  { id: 'sleepcap', label: 'Сонный колпак' },
  { id: 'pirate', label: 'Пиратская треуголка' },
  { id: 'chef', label: 'Колпак повара' },
  { id: 'cowboy', label: 'Ковбойская шляпа' },
  { id: 'panama', label: 'Летняя панама' },
  { id: 'aviator', label: 'Шлем авиатора' },
  { id: 'unicorn', label: 'Ободок единорога' },
  { id: 'leafcrown', label: 'Лесной венок' },
] as const;
export const ACTIVITIES = [
  { id: 'calm', label: 'Спокойный', description: 'Чаще отдыхает, реже отвлекает' },
  { id: 'balanced', label: 'Любопытный', description: 'Гуляет, наблюдает и иногда играет' },
  { id: 'playful', label: 'Игривый', description: 'Чаще исследует страницу и играет' },
] as const;
export const CAT_SIZES = [
  { id: 'small', label: 'Маленький', pixels: 88 },
  { id: 'medium', label: 'Средний', pixels: 112 },
  { id: 'large', label: 'Большой', pixels: 136 },
] as const;

export interface MascotProfile {
  name: string;
  cat: typeof CAT_TYPES[number]['id'];
  coat: typeof COAT_COLORS[number]['id'];
  eyes: typeof EYE_COLORS[number]['id'];
  neckwear: typeof NECKWEAR[number]['id'];
  headwear: typeof HEADWEAR[number]['id'];
  accessoryColor: typeof ACCESSORY_COLORS[number]['id'];
  activity: typeof ACTIVITIES[number]['id'];
  size: typeof CAT_SIZES[number]['id'];
  menuPlay: boolean;
  textPlay: boolean;
  hunger: boolean;
}

export const isDog = (cat: MascotProfile['cat']): boolean => cat === 'bulldog' || cat === 'vizsla' || cat === 'pied';
/** Логин основного аккаунта заказчика; имя и роль не дают личного персонажа. */
export const canUseDracula = (owner: { username?: string | null } | null | undefined): boolean => owner?.username?.toLowerCase() === 'yana';
export const nativePetColors = (cat: MascotProfile['cat']) => CAT_TYPES.find(item => item.id === cat)!;

export function defaultMascotProfile(): MascotProfile {
  return {
    name: 'Ночка', cat: 'fluffy', coat: 'black', eyes: 'green',
    neckwear: 'none', headwear: 'none', accessoryColor: 'blue',
    activity: 'balanced', size: 'medium', menuPlay: true, textPlay: true, hunger: true,
  };
}

function choice<T extends string>(value: unknown, options: readonly { id: T }[], fallback: T): T {
  return options.find((option) => option.id === value)?.id ?? fallback;
}

/** Хранилище может содержать старую версию настроек или некорректный JSON. */
export function normalizeMascotProfile(value: unknown): MascotProfile {
  const fallback = defaultMascotProfile();
  const raw = value && typeof value === 'object' ? value as Record<string, unknown> : {};
  const profile: MascotProfile = {
    name: typeof raw.name === 'string' ? [...raw.name].filter((char) => char.charCodeAt(0) > 31 && char.charCodeAt(0) !== 127).join('').trim().slice(0, 24) || fallback.name : fallback.name,
    cat: choice(raw.cat, CAT_TYPES, fallback.cat),
    coat: choice(raw.coat, COAT_COLORS, fallback.coat),
    eyes: choice(raw.eyes, EYE_COLORS, fallback.eyes),
    neckwear: choice(raw.neckwear, NECKWEAR, fallback.neckwear),
    headwear: choice(raw.headwear, HEADWEAR, fallback.headwear),
    accessoryColor: choice(raw.accessoryColor, ACCESSORY_COLORS, fallback.accessoryColor),
    activity: choice(raw.activity, ACTIVITIES, fallback.activity),
    size: choice(raw.size, CAT_SIZES, fallback.size),
    menuPlay: typeof raw.menuPlay === 'boolean' ? raw.menuPlay : fallback.menuPlay,
    textPlay: typeof raw.textPlay === 'boolean' ? raw.textPlay : fallback.textPlay,
    hunger: typeof raw.hunger === 'boolean' ? raw.hunger : fallback.hunger,
  };
  // Авторский костюм нарисован в каждом кадре. Его нельзя перекрасить вместе с шерстью.
  if (profile.cat === 'dracula') Object.assign(profile, { coat: 'black', eyes: 'red', neckwear: 'none', headwear: 'none', accessoryColor: 'red' });
  return profile;
}

export function normalizeOwnedMascotProfile(value: unknown, owner: Parameters<typeof canUseDracula>[0]): MascotProfile {
  const profile = normalizeMascotProfile(value);
  if (!canUseDracula(owner)) {
    if (profile.cat === 'dracula') profile.cat = 'fluffy';
    if (profile.neckwear === 'vampire') profile.neckwear = 'none';
  }
  return profile;
}

/** Готовые варианты можно менять дальше, независимо от остальных пользователей. */
export const CAT_PRESETS: { id: string; label: string; profile: Partial<MascotProfile> }[] = [
  { id: 'mainecoon', label: 'Мейн-кун', profile: { cat: 'mainecoon', coat: 'brown', eyes: 'green' } },
  { id: 'siamese', label: 'Сиамская', profile: { cat: 'siamese', coat: 'cream', eyes: 'blue' } },
  { id: 'bengal', label: 'Бенгальская', profile: { cat: 'bengal', coat: 'ginger', eyes: 'green' } },
  { id: 'persian', label: 'Персидская', profile: { cat: 'persian', coat: 'white', eyes: 'amber' } },
  { id: 'sphynx', label: 'Сфинкс', profile: { cat: 'sphynx', coat: 'silver', eyes: 'green' } },
  { id: 'night', label: 'Чёрный пушистый', profile: { cat: 'fluffy', coat: 'black', eyes: 'green' } },
  { id: 'coal', label: 'Чёрный плюшевый', profile: { cat: 'plush', coat: 'black', eyes: 'amber' } },
  { id: 'ginger', label: 'Рыжий', profile: { cat: 'fluffy', coat: 'ginger', eyes: 'amber' } },
  { id: 'red', label: 'Красный', profile: { cat: 'plush', coat: 'red', eyes: 'green' } },
  { id: 'cream', label: 'Светлый', profile: { cat: 'fluffy', coat: 'cream', eyes: 'blue' } },
  { id: 'brown', label: 'Каштановый', profile: { cat: 'plush', coat: 'brown', eyes: 'amber' } },
  { id: 'dracula', label: 'Дракула · личный хранитель Яны', profile: { name: 'Дракула', cat: 'dracula', coat: 'black', eyes: 'red', neckwear: 'none', headwear: 'none', accessoryColor: 'red' } },
  { id: 'bulldog', label: 'Французский бульдог', profile: { cat: 'bulldog', coat: 'cream', eyes: 'amber' } },
  { id: 'chapa', label: 'Чапа · рыжая выжла', profile: { name: 'Чапа', cat: 'vizsla', coat: 'ginger', eyes: 'amber' } },
  { id: 'pied', label: 'Бульдог с фотографии', profile: { cat: 'pied', coat: 'white', eyes: 'amber' } },
];
